/* eslint-disable react/jsx-props-no-spreading */

import clsx from 'clsx'

import Button from 'app/shared-components/Button'

import useStyles from './DropZone.styles'

type Props = {
    getRootProps: () => object,
    getInputProps: () => object,
    isDragActive: boolean,
    isDragReject: boolean,
    open: () => void,
    required: boolean,
    disabled: boolean,
    multiple: boolean,
}

function DropZone({
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    open,
    required,
    disabled,
    multiple,
}: Readonly<Props>) {
    const {
        classes,
    } = useStyles()

    const dropText = multiple ? 'Drop files here' : 'Drop a file here'
    const selectText = multiple ? 'Select Files' : 'Select a file'

    return (
        <div
            className={classes.container}
            data-testid="attachment-drop-zone"
        >
            <div
                className={clsx(classes.baseStyle, {
                    [classes.activeStyle]: isDragActive,
                    [classes.rejectStyle]: isDragReject,
                    [classes.required]: required,
                    [classes.disabled]: disabled,
                })}
                {...getRootProps()}
            >
                <input {...getInputProps()} />
                <span className={clsx(classes.text, {
                    [classes.activeStyleText]: isDragActive,
                    [classes.textRequired]: required,
                    [classes.textDisabled]: disabled,
                })}
                >
                    {dropText}
                </span>
                <span className={clsx(classes.text, {
                    [classes.activeStyleText]: isDragActive,
                    [classes.textRequired]: required,
                    [classes.textDisabled]: disabled,
                })}
                >
                    or
                </span>
                <Button
                    label={selectText}
                    key="select-files"
                    onClick={open}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}

export default DropZone
